import { COMPANY } from './company'

export const CITIES = [
  'Bengaluru',
  'Mumbai',
  'Delhi NCR',
  'Hyderabad',
  'Pune',
] as const

export type City = (typeof CITIES)[number]

export const TOPBAR = {
  headline: 'Fresh Flowers, Plants & Gifts',
  cities: '80+ Cities',
  gifting: 'Corporate & Personal Gifting',
  phoneDisplay: COMPANY.phoneDisplay,
  phoneHref: COMPANY.phoneHref,
} as const

export const DEFAULT_CITY = CITIES[0]

export const NAV_CATEGORY_ALL_LABEL = 'All'
